import { Country } from 'components';
import i18n from '../i18n';

// FIXME(valerie): 유니코드 관련된 npm 패키지를 이용해 간단하게 거르는 방법도 있으나 이건
// 유니코드 데이터를 모두 들고 있어야 해서 main.js가 무거워질 수도 있습니다.
// 마음이 아프지만 일단 알파벳, 공백, 한글자모, 한글음절, 가나, 한자 만 러프하게 통과시키도록 합니다.
// 알파벳 외의 라틴 문자들이 들어있는 블록을 모으기는 너무 번거로우므로 마음이 아프지만 일단 하지 않습니다.
export function isValidLetter(
    _char: string,
    spaceAllowed = false
): [boolean, string] {
  let block = '';
  if (isHangul(_char)) {
    block = 'HANGUL';
  } else if (isAlphabet(_char)) {
    block = 'ALPHABET';
  } else if (isKana(_char)) {
    block = 'KANA';
  } else if (isHanja(_char)) {
    block = 'CJK';
  } else if (isAvailableMark(_char)) {
    block = 'MARK';
  } else if (_char === ' ' && spaceAllowed) {
    block = 'SPACE';
  } else {
    return [false, block];
  }
  return [true, block];
}

export function isCharBetween(hexMin: number, _char: string, hexMax: number) {
  return hexMin <= _char.charCodeAt(0) && _char.charCodeAt(0) <= hexMax;
}

export function isAvailableMark(_char: string) {
  let availableMarks = [0x3005]; // iteation mark '々' used in Japan
  return availableMarks.indexOf(_char.charCodeAt(0)) > -1;
}

export function isHanja(_char: string) {
  return (
        isCharBetween(0x2e80, _char, 0x2fdf) || // CJK Radicals Supplement, Kangxi Radicals
        isCharBetween(0x3400, _char, 0x4dbf) || // CJK Unified Ideographs Extension A
        isCharBetween(0x4e00, _char, 0x9fff) || // CJK Unified Ideographs
        isCharBetween(0xf900, _char, 0xfaff)
  ); // CJK Compatibility Ideographs
}
export function isHangul(_char: string) {
  return (
        isCharBetween(0x1100, _char, 0x11ff) || // Hangul Jamo
        isCharBetween(0x3130, _char, 0x318f) || // Hangul Compatibility Jamo
        isCharBetween(0xac00, _char, 0xd7af)
  ); // Hangul Syllables
}

export function isHangulSyllable(_char: string) {
  return isCharBetween(0xac00, _char, 0xd7af); // Hangul Syllables
}

export function isKana(_char: string) {
  return (
        isCharBetween(0x30a0, _char, 0x30ff) || // Katakana
        isCharBetween(0x3040, _char, 0x309f) || // Hiragana
        isCharBetween(0x31f0, _char, 0x31ff) || // Katakana Phonetic Extensions
        isCharBetween(0xff66, _char, 0xff9e)
  ); // 카타카나 반각
}

export function isAlphabet(_char: string) {
  return (
        isCharBetween(0x0041, _char, 0x005a) ||
        isCharBetween(0x0061, _char, 0x007a) // 알파벳 대문자
  ); // 알파벳 소문자
}

export function isLetterOnlyString(string: string, spaceAllowed = false) {
  for (let i = 0; i < string.length; i++) {
    if (!isValidLetter(string[i], spaceAllowed)[0]) {
      return false;
    }
  }
  return true;
}

export function validateCustomerAge(
    age: string,
    locale: Country
): [boolean, string] {
  if (age === '' || Number(age) < 0) {
    return [false, i18n.t('나이를 정확히 입력해주세요.')];
  }

  if (locale === Country.KR) {
    if (Number(age) >= 14) {
      return [true, ''];
    } else {
      return [
        false,
        i18n.t(
                    '만 14세 미만의 경우 회원가입 서비스 이용이 제한됩니다.'
                ),
      ];
    }
  }
  return [true, ''];
}

export function validateCustomerBirthday(birthday: string): [boolean, string] {
  if (birthday.length !== 5) {
    return [false, i18n.t('생일을 정확히 입력해주세요.')];
  }

  return [true, ''];
}

export function validateCustomerName(name: string): [boolean, string] {
  if (name === '') {
    return [false, i18n.t('1자 이상의 이름을 정확히 입력해주세요.')];
  }

    // 양 옆 공백은 제거
  name = name.trim();

    // 글자수 검사
  if (name.length > 30) {
    return [false, i18n.t('이름은 30자까지 등록 가능합니다.')];
  }
    // 글자 외의 문자를 썼는지 검사
  if (!isLetterOnlyString(name, true)) {
    return [
      false,
      i18n.t('공백, 특수문자, 이모티콘은 사용할 수 없습니다.'),
    ];
  }
  let blockName = isValidLetter(name[0])[1];
  let nextBlockName = null;
  let spaceNotAllowed = ['HANGUL'];
  let combineAllowed = ['CJK', 'KANA', 'MARK'];

    // 언어 혼용 검사
  for (let i = 0; i < name.length; i++) {
    nextBlockName = isValidLetter(name[i], true)[1];
    if (
            blockName !== nextBlockName &&
            !(
                combineAllowed.indexOf(blockName) > -1 &&
                combineAllowed.indexOf(nextBlockName) > -1
            ) &&
            nextBlockName !== 'SPACE'
        ) {
      return [false, i18n.t('이름은 한 가지 언어로 입력해주세요.')];
    }
  }

    // 이름 사이 공백 검사
  if (spaceNotAllowed.indexOf(blockName) > -1) {
        // 한글은 이름 사이 공백 금지
    if (!isLetterOnlyString(name)) {
      return [
        false,
        i18n.t('공백, 특수문자, 이모티콘은 사용할 수 없습니다.'),
      ];
    }

    if (blockName === 'HANGUL') {
            // 한글은 자음, 모음 단독 사용 금지
      for (let i = 0; i < name.length; i++) {
        if (!isHangulSyllable(name[i])) {
          return [
            false,
            i18n.t('1자 이상의 이름을 정확히 입력해주세요.'),
          ];
        }
      }
    }
  }
  return [true, ''];
}
